<template>

    <div class="form-group">

        <label for="vehicletype_id">
            <strong>
                Vehicle Type
                <span v-if="required" class="text-danger">*</span>
            </strong>
        </label>

        <v-select
            v-model="selectedVehicleType"
            :options="vehicleTypes"
            label="type"
            :clearable="false"
            placeholder="Select a Vehicle Type"
            :disabled="vehicleTypes.length <= 1"
            :required="required"
        />

        <input type="hidden" name="vehicletype_id" :value="selectedVehicleType ? selectedVehicleType.id : ''">

        <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
            {{ error }}
        </div>

    </div>

</template>

<script>

import VSelect from 'vue-select';

export default {

    props: {
        vehicle: {
            type: Object,
            required: false,
        },
        vehicleTypes: {
            type: Array,
            required: true,
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedVehicleType: null,
        }
    },

    mounted() {

        if ( this.vehicleTypes.length === 1 ) {
            this.selectedVehicleType = this.vehicleTypes[0];
        }

        if ( this.old ) {
            this.selectedVehicleType = this.vehicleTypes.find( vehicleType => vehicleType.id === this.old );
        }

        if ( this.vehicle ) {
            this.selectedVehicleType = this.vehicleTypes.find( vehicleType => vehicleType.id === this.vehicle.vehicletype_id );
        }

    },

}

</script>
